import { render, staticRenderFns } from "./categorias.vue?vue&type=template&id=b36ee89c&scoped=true&"
import script from "./categorias.vue?vue&type=script&lang=js&"
export * from "./categorias.vue?vue&type=script&lang=js&"
import style0 from "./categorias.vue?vue&type=style&index=0&id=b36ee89c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36ee89c",
  null
  
)

export default component.exports